import React from 'react';
import { Link } from 'react-router-dom';
import "./stem.css";
import { FaArrowLeft, FaFlask, FaAtom, FaDna, FaCalculator, FaChalkboardTeacher } from 'react-icons/fa';

const SciencePage = () => {
  const programCategories = [
    {
      title: "Competitive Exam Preparation",
      description: "Comprehensive coaching for top science entrance exams",
      courses: [
        { name: "IIT JAM Coaching", description: "Specialized coaching for Joint Admission Test for Masters in Science disciplines", icon: <FaCalculator /> },
        { name: "GATE Science Programs", description: "Graduate Aptitude Test in Engineering preparation for science streams", icon: <FaChalkboardTeacher /> },
        { name: "CSIR NET / SET Exam Coaching", description: "Preparation for National & State Eligibility Tests for research and lectureship", icon: <FaChalkboardTeacher /> },
        { name: "Public Service Exams (Science Stream)", description: "Preparation for scientific roles in state and central government services", icon: <FaChalkboardTeacher /> }
      ]
    },
    {
      title: "Core Science Programs",
      description: "Deep-dive into fundamental scientific disciplines",
      courses: [
        { name: "Advanced Mathematics", description: "Higher mathematics including calculus, linear algebra, statistics, and mathematical modeling", icon: <FaCalculator /> },
        { name: "Physics Studies", description: "Classical and modern physics with experimental focus", icon: <FaAtom /> },
        { name: "Chemistry Excellence", description: "Organic, inorganic, physical chemistry and lab techniques", icon: <FaFlask /> },
        { name: "Life Sciences & Biotechnology", description: "Cell biology, genetics, microbiology and biotechnology applications", icon: <FaDna /> }
      ]
    },
    {
      title: "Research & Methodology",
      description: "Skill development for scientific careers and research",
      courses: [
        { name: "Scientific Research Methodology", description: "Learn experimental design, hypothesis testing, and scientific writing", icon: <FaChalkboardTeacher /> },
        { name: "Data Analysis for Scientists", description: "Statistical analysis, data visualization, and scientific computing", icon: <FaCalculator /> },
        { name: "Laboratory Techniques", description: "Hands-on training for advanced scientific instruments and lab protocols", icon: <FaFlask /> },
        { name: "Non-IT to IT Transition", description: "Programming and computational skills for science professionals", icon: <FaChalkboardTeacher /> }
      ]
    }
  ];

  return (
    <div className="program-page science-theme py-5 my-5">
      <div className="program-header">
        <Link to="/" className="text-start ">
          <FaArrowLeft /> Back to Programs
        </Link>
        <div className="program-title">
          <FaFlask className="program-header-icon" />
          <h1>Science Programs</h1>
        </div>
        <p className="program-subtitle">Advanced scientific concepts, research methodologies, and exam preparation</p>
      </div>

      <div className="program-overview">
        <h2>Why Choose Our Science Coaching?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>Expert Faculty</h3>
            <p>Learn from PhD holders and industry experts with proven teaching excellence</p>
          </div>
          <div className="feature-card">
            <h3>Research-Oriented</h3>
            <p>Curriculum designed to develop critical thinking and scientific temperament</p>
          </div>
          <div className="feature-card">
            <h3>Practical Focus</h3>
            <p>Hands-on laboratory sessions and real-world problem solving</p>
          </div>
          <div className="feature-card">
            <h3>Small Batch Sizes</h3>
            <p>Personalized attention with limited students per batch</p>
          </div>
        </div>
      </div>

      <div className="courses-section">
        {programCategories.map((category, index) => (
          <div className="course-category" key={index}>
            <h2>{category.title}</h2>
            <p className="category-description">{category.description}</p>
            
            <div className="courses-grid">
              {category.courses.map((course, courseIndex) => (
                <div className="course-card" key={courseIndex}>
                  <div className="course-icon">{course.icon}</div>
                  <h3>{course.name}</h3>
                  <p>{course.description}</p>
                  <button className="enroll-btn">Learn More</button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="testimonials-section">
        <h2>Success Stories</h2>
        <div className="testimonials-container">
          <div className="testimonial-card">
            <p>"The IIT JAM coaching program helped me secure AIR 45. The quantitative problem-solving approach and mock tests were incredibly helpful."</p>
            <p className="testimonial-author">- Priya S., IIT Delhi</p>
          </div>
          <div className="testimonial-card">
            <p>"The lab sessions and research methodology training gave me a strong foundation for my PhD program. Highly recommended for serious science students."</p>
            <p className="testimonial-author">- Rohit M., Research Scholar</p>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <h2>Ready to Excel in Science?</h2>
        <p>Join our specialized coaching programs and build a strong foundation for your career in science</p>
        <button className="primary-btn">Schedule a Free Consultation</button>
      </div>
    </div>
  );
};

export default SciencePage;